function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import t from 'prop-types';
import * as Util from '../util';
import Precarga from '../precarga';

var imagenSrcBlanca = function imagenSrcBlanca(libroId) {
  return 'contenido/' + libroId + '.png';
};

var imagenSrc = function imagenSrc(libroId, numPagina) {
  return 'contenido/' + libroId + Util.pad3(numPagina) + '.jpg';
}; // const imagenSrcAlta = (libroId, numPagina) => 'contenido/' + libroId + Util.pad3(numPagina) + '.png';


var ImagenPagina = function (_Component) {
  _inherits(ImagenPagina, _Component);

  function ImagenPagina(props) {
    _classCallCheck(this, ImagenPagina);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleImageLoad = function (e) {
      var src = e.target.src; // window.setTimeout(() => {            

      _this.setState({
        src: src,
        loading: false
      }); // }, 2000);        

    };

    _this.state = {
      src: imagenSrcBlanca(props.libroId),
      // srcAlta: imagenSrcAlta(props.libroId, props.numPagina),
      loading: true
    };
    return _this;
  }

  ImagenPagina.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    var _props = this.props,
        libroId = _props.libroId,
        numPagina = _props.numPagina;

    if (libroId !== prevProps.libroId || numPagina !== prevProps.numPagina) {
      var srcBaja = imagenSrc(libroId, numPagina);
      this.setState({
        src: imagenSrcBlanca(libroId),
        // srcAlta: imagenSrcAlta(libroId, numPagina), 
        loading: true
      }, function () {
        return _this2.cargarImagen(srcBaja);
      });
    }
  };

  ImagenPagina.prototype.cargarImagen = function cargarImagen(src) {
    if (this.imagen) {
      this.imagen.removeEventListener('load', this.handleImageLoad, false);
    }

    this.imagen = new Image();
    this.imagen.addEventListener('load', this.handleImageLoad, false);
    this.imagen.src = src;
  };

  ImagenPagina.prototype.componentDidMount = function componentDidMount() {
    var _props2 = this.props,
        libroId = _props2.libroId,
        numPagina = _props2.numPagina;
    this.cargarImagen(imagenSrc(libroId, numPagina));
  };

  ImagenPagina.prototype.componentWillUnmount = function componentWillUnmount() {
    this.imagen.removeEventListener('load', this.handleImageLoad, false);
  };

  ImagenPagina.prototype.render = function render() {
    var id = this.props.id; // const output = [
    //     // <pre key='imagen-pagina-info'>{JSON.stringify(this.state).split(',').join('\n')}</pre>,
    //     <img key='imagen-pagina' id={ id } className='imagenPagina' src={ this.state.src } alt=''/>,
    //     <img key='imagen-pagina-alta' id={`${id}_alta`} style={{display: 'none'}} src={ this.state.srcAlta } alt='' />
    // ];
    // if (this.state.loading) {
    //     output.push(<Precarga key='imagen-loader' style={{position: 'initial'}}/>)
    // }

    return React.createElement(React.Fragment, null, this.state.loading && React.createElement(Precarga, {
      style: {
        position: 'initial'
      }
    }), React.createElement('img', {
      id: id,
      className: 'imagenPagina',
      src: this.state.src,
      alt: ''
    })); // return output;
  };

  return ImagenPagina;
}(Component);

ImagenPagina.propTypes = process.env.NODE_ENV !== "production" ? {
  libroId: t.string,
  numPagina: t.number,
  id: t.string
} : {};
export default ImagenPagina;